<template>
    <div class="fw-odfx">
        <van-nav-bar :title="title" style="background-color: #CCD5E6;" left-text="" @click-left="onClickLeft" left-arrow
                     :fixed="true">
        </van-nav-bar>
        <div class="sousuo">
            <div class="sou-item">
                <el-input v-model="bmtjname" size="mini" placeholder="部门条件" disabled></el-input>
                <span class="bmBtn1" @click="bmCondition">部门条件</span>
                <span class="bmBtn2" @click="qingchu">清除</span>
            </div>
            <div class="sou-item">
                <el-select v-model="lvId" size="mini" clearable style="width: 100%" placeholder="请选择级别">
                    <el-option
                            v-for="item in lvs"
                            :key="item.id"
                            :label="item.plusName"
                            :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="sou-item">
                <el-input v-model="phone" size="mini" style="width: 100%" placeholder="请输入手机号"></el-input>
            </div>
        </div>
        <Cxdate @chaxun="chaxun"/>
        <div style="margin-top: 10px">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <div class="oo-items" v-for="(item,index) in list">
                    <div class="mbinfo">
                        <div>
                            <img v-if="item.headPortrait" :src="item.headPortrait" class="my-tou"/>
                            <div v-else>
                                <img v-if="item.sex==0" src="./../../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==1" src="./../../../assets/nan.png" class="my-tou"/>
                                <img v-if="item.sex==2" src="./../../../assets/nv.png" class="my-tou"/>
                            </div>
                        </div>
                        <div class="my-mbinfo">
                            <span>{{item.memberName}}</span>
                            <span style="font-size: 10px;margin-left: 0px">
                            <span style="background-color: gainsboro;padding: 0 10px;">{{item.lvName==null?'PLUS: 未开通':item.lvName}}</span>
                            </span>
                        </div>
                    </div>
                    <div>
                        <div style="display: flex;flex-direction: row;justify-content: space-between">
                            <div class="nr-item1" style="margin-bottom: 0px;">
                                <span>成交订单(份)</span>
                                <span>{{item.orderNum}}</span>
                            </div>
                            <div class="nr-item1" style="margin-bottom: 0px;">
                                <span>成交金额(元)</span>
                                <span style="color: #BF6A86">{{item.payPrice}}</span>
                            </div>
                        </div>
                        <div class="yyfx-item">
                            <div class="yyfx-item-bt">
                                <span>支出分析</span>
                            </div>
                            <div class="yyfx-nr1">
                                <div class="nr-item1">
                                    <span v-if="item.sy">{{item.sy.zjxsCmn}}</span>
                                    <span v-if="!item.sy">0</span>
                                    <span>直接销售提成</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.sy">{{item.sy.jjBonus}}</span>
                                    <span v-if="!item.sy">0</span>
                                    <span>间接奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.sy">{{item.sy.bmBonus}}</span>
                                    <span v-if="!item.sy">0</span>
                                    <span>部门分润</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.sy">{{item.sy.pjBonus}}</span>
                                    <span v-if="!item.sy">0</span>
                                    <span>平级奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span>0</span>
                                    <span>伯乐奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span>0</span>
                                    <span>分红</span>
                                </div>
                            </div>
                        </div>
                        <div class="yyfx-item">
                            <div class="yyfx-item-bt">
                                <span>已结算分析</span>
                            </div>
                            <div class="yyfx-nr1">
                                <div class="nr-item1">
                                    <span v-if="item.yjs">{{item.yjs.zjxsCmn}}</span>
                                    <span v-if="!item.yjs">0</span>
                                    <span>直接销售提成</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.yjs">{{item.yjs.jjBonus}}</span>
                                    <span v-if="!item.yjs">0</span>
                                    <span>间接奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.yjs">{{item.yjs.bmBonus}}</span>
                                    <span v-if="!item.yjs">0</span>
                                    <span>部门分润</span>
                                </div>
                                <div class="nr-item1">
                                    <span v-if="item.yjs">{{item.yjs.pjBonus}}</span>
                                    <span v-if="!item.yjs">0</span>
                                    <span>平级奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span>0</span>
                                    <span>伯乐奖金</span>
                                </div>
                                <div class="nr-item1">
                                    <span>0</span>
                                    <span>分红</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </div>
        <van-popup v-model="bmShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 100%;overflow:hidden;padding-bottom: 50px;background-color: #FAFAFA">
             <span class="md-bt">
                    <span>查询条件</span>
                    <i class="el-icon-close" @click="guanbi"></i>
             </span>
            <div class="bmlist">
                <el-input placeholder="输入部门名称可筛选部门" v-model="bmName" size="mini" style="width: 100%">
                    <el-button slot="append" icon="el-icon-search" @click="sousuo"></el-button>
                </el-input>
            </div>
            <div style="font-size: 15px;padding: 5px;margin-top: 18px">
                <span>条件1 <span style="font-size: 10px;color: #b5b5b5">( 查询全部事业部负责人 )</span></span>
            </div>
            <div class="bmtj" @click="setBm('FZR')">
                <span class="qbcsr">部门负责人</span>
            </div>
            <div style="font-size: 15px;padding: 5px;margin-top: 18px">
                <span>条件2 <span style="font-size: 10px;color: #b5b5b5">( 可查询指定事业部全部成员 )</span></span>
            </div>
            <div class="bmtj" v-for="bm in sxbms" @click="setBm('SYB',bm)">
                <span class="qbcsr">{{bm.bmName}}</span>
            </div>
        </van-popup>
    </div>
</template>

<script>
    import {getCookie} from "../../../utils/auth";
    import Cxdate from "./../../common/cxdate.vue";

    export default {
        components: {Cxdate},
        data() {
            return {
                title: '推广分析',
                fwUser: {},
                deptId: '',
                token: '',
                userType: '',
                dateType: 0,
                staDate: '',
                endDate: '',

                phone: '',
                list: [],
                page: 1,
                loading: false,
                finished: false,

                sdiId: '',
                identitys: [],
                lvId: '',
                lvs: [],


                bmName: '',
                bmShow: false,
                bms: [],
                sxbms: [],

                bmType: '',
                bmtjname: '',
                bmId:'',
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            this.getCondition()
        },
        methods: {
            async getCondition() {
                let data = {
                    deptId: this.deptId,
                    token: this.token
                }
                let res = await this.$get("/fw/getTgCondition", data)
                this.bms = res.bms
                this.sxbms = res.bms
                this.lvs = res.lvs
            },
            bmCondition() {
                this.bmShow = true
            },
            qingchu(){
                this.bmName=''
                this.sxbms=this.bms
                this.bmType=''
                this.bmId=''
                this.bmtjname=''
            },
            chaxun(data) {
                this.dateType = data.dateType
                this.staDate = data.staDate
                this.endDate = data.endDate
                this.page = 1
                this.list = []
                this.loading = false
                this.finished = false
                this.onLoad()
            },
            async onLoad() {
                if (!this.bmType && !this.lvId && !this.phone) {
                    // 加载状态结束
                    this.loading = false;
                    this.finished = true;
                    return;
                } else {
                    this.loading = true;
                    this.finished = false;
                }
                let currentPage = this.page || 1;
                let data = {
                    token: this.token,
                    dateType: this.dateType,
                    staDate: this.staDate,
                    endDate: this.endDate,
                    phone: this.phone,
                    bmType: this.bmType,
                    divisionId: this.bmId,
                    lvId: this.lvId,
                    isSettlement: this.active,
                    currentPage
                }
                let res = await this.$get("/fw/getFwTgAnalysis", data)
                if (res.code == 200) {
                    const count =res.dataSet.list.length
                    const newList =res.dataSet.list
                    const list =this.list.concat(newList)
                    if (list.length<30){
                        this.list = this.quchong(list,"id")
                    }else {
                        this.list =list
                    }
                    this.page=this.page+1
                    this.loading = false
                    if (count<10&&count==0){
                        this.finished = true
                    }
                }else {
                    this.finished = true
                }
            },

            sousuo() {
                var name = this.bmName.replace(/\s+/g, "");
                let bms = []
                this.bms.forEach(item => {
                    var newStr = item.bmName.replace(/\s+/g, "");
                    let b = newStr.toUpperCase().match(name.toUpperCase())
                    if (b) {
                        bms.push(item)
                    }
                })
                if (bms.length > 0) {
                    this.sxbms = bms
                } else {
                    this.sxbms = []
                }
            },

            setBm(bmType, bm) {
                if (bmType == 'FZR') {
                    this.bmtjname = '部门负责人'
                }
                if (bmType == 'SYB') {
                    this.bmtjname = bm.bmName
                    this.bmId = bm.id
                }
                this.bmType = bmType
                this.guanbi()
            },

            guanbi() {
                this.bmShow = false
            },
            onClickLeft() {
                this.$router.go(-1)
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-odfx {
        margin: 0 auto;
        height: 100%;
        position: relative;
        overflow: scroll;
        padding-top: 46px;
        padding-bottom: 49px;
        background-color: #F2F1F6;
    }

    .sousuo {
        background-color: #FFFFFF;
        padding-top: 10px;
    }

    .sou-item {
        padding: 0 38px;
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 35px;
    }

    .xiantiao {
        border-bottom: #CAC6C7 solid 1px;
        height: 1px;
    }

    .mbinfo {
        display: flex;
        flex-direction: row;
        padding: 10px 10px 0 10px;
        border-bottom: #C0BEC0 solid 1px;
    }

    .my-tou {
        height: 40px;
        width: 40px;
    }

    .my-mbinfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }

    .my-mbinfo span {
        font-size: 13px;
        height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-left: 16px
    }

    .oo-items {
        background-color: #FFFFFF;
        margin: 10px;
        padding: 0 8px;
    }

    .ooinfo {
        padding: 8px 16px;
    }

    .ooinfo-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 11px;
    }

    .oi-name {
        width: 90px;
        height: 25px;
        line-height: 25px;
    }

    .oi-val {
        height: 25px;
        line-height: 25px;
    }

    .yyfx-item {
        margin: 10px;
        background-color: #FFFFFF;
        padding: 8px;
    }

    .yyfx-item-bt {
        font-size: 13px;
        padding-top: 8px;
        padding-bottom: 7px;
    }

    .yyfx-item-bt span {
        border-left: #2E3191 solid 3px;
        padding-left: 5px;
    }

    .yyfx-nr1 {
        display: flex;
        flex-flow: row wrap;
        padding-top: 10px;
    }

    .nr-item1 {
        flex: 1;
        box-sizing: border-box;
        padding: 5px;
        margin-bottom: 16px;
        display: flex;
        flex-direction: column;
        font-size: 11px;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .nr-item1 span {
        text-align: center;
        height: 28px;
        line-height: 28px;
    }

    .bmBtn1 {
        font-size: 12px;
        width: 90px;
        height: 25px;
        line-height: 25px;
        margin-left: 8px;
        text-align: center;
        background-color: #2b94ff;
        color: #FFFFFF;
        border-radius: 3px;
        padding: 0 5px;
    }
    .bmBtn2 {
        font-size: 12px;
        width: 55px;
        height: 25px;
        line-height: 25px;
        margin-left: 8px;
        text-align: center;
        background-color: #2b94ff;
        color: #FFFFFF;
        border-radius: 3px;
        padding: 0 5px;
    }

    .md-bt {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        font-size: 15px;
        border-bottom: #dddddd solid 1px;
        padding: 10px;
        background-color: #FFFFFF;
    }

    .bmlist {
        background-color: #FFFFFF;
        padding: 0 15px 15px 15px;
    }

    .bmtj {
        height: 30px;
        line-height: 30px;
        background-color: #FFFFFF;
        margin: 5px 5px 0 5px;
    }

    .qbcsr {
        display: block;
        font-size: 13px;
        padding: 0 10px;
    }
</style>